// extracted by mini-css-extract-plugin
export var hero = "home-module--hero--3kPNJ";
export var heroTitle = "home-module--hero-title--Pi3kT";
export var promotion = "home-module--promotion--2pYzK";
export var seeAll = "home-module--see-all--vBGfX";
export var about = "home-module--about--RcrUb";
export var aboutTitle = "home-module--about-title--3zeHN";
export var aboutText = "home-module--about-text--30d5z";
export var contactForm = "home-module--contactForm--3_5yj";